import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[mbsInputLabel]'
})
export class InputLabelDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);
}
